<template>
  <rect
    class="hc-stacked-rect"
    :x="Dimention.x"
    :y="Dimention.y"
    :width="Dimention.width"
    :height="Dimention.height"
    :fill="color"
    stroke="transparent"
  />
</template>

<script>
import tween from '../libraries/tween'
export default {
  name: 'Stack',
  props: {
    dimention: {
      type: Object,
      default () { return {x:0, y:0, width:0, height: 0}}
    },
    color: {
      type: String,
      default: '#f56043'
    },
    animation: {
      type: Boolean,
      default: true
    },
    animationDuration: {
      type: Number,
      default: 3000
    },
    animationOptions: {
      type: Object,
      default () {
        return {
          delay: 0,
          easing: 'Bounce',
          easingEdge: 'Out'
        }
      }
    }
  },
  data () {
    return {
      Dimention: {x:0, y:0, width:0, height: 0}
    }
  },
  mounted () {
    if (this.animation) {
      tween(this.dimention, {x: this.dimention.x, y: this.dimention.y, width: this.dimention.width, height: 0}, this.animationDuration, (dimention) => {
        this.Dimention = dimention
      }, this.animationOptions)
    } else {
      this.Dimention = this.dimention
    }
  },
  watch: {
    dimention (newDim, oldDim) {
      if (this.animation && oldDim.x) {
        tween(newDim, {x: oldDim.x, y: oldDim.y, width: oldDim.width, height: 0}, this.animationDuration, (dimention) => {
          this.Dimention = dimention
        }, this.animationOptions)
      } else {
        this.Dimention = newDim
      }
    }
  }
}
</script>

<style>

</style>
